/**
 * Formats an input string representing a time (HHMM or similar) into the `HH:MM` format.
 *
 * - Removes all non-digit characters.
 * - Limits the value to 4 digits.
 * - Ensures that hours do not exceed 23 and minutes do not exceed 59.
 *
 * @param {string} value - A string containing numbers that represent a time.
 * @returns {string} A string formatted as `HH:MM` if possible, or the sanitized original string.
 *
 * @example
 * formatTime('0930') // Returns '09:30'
 * formatTime('2459') // Returns '23:59'
 * formatTime('9999') // Returns '23:59'
 * formatTime('1')    // Returns '1'
 */

export const formatTime = (value: string): string => {
  let formatted = value.replace(/\D/g, '')

  if (formatted.length > 4) formatted = formatted.slice(0, 4)

  if (formatted.length > 3) {
    let hours = parseInt(formatted.slice(0, 2), 10)
    let minutes = parseInt(formatted.slice(2, 4) || '0', 10)

    if (hours > 23) hours = 23
    if (minutes > 59) minutes = 59

    formatted = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
  }

  return formatted
}
